import { gql } from 'apollo-boost'

const START_HTML_MENU_SCRAPING_SESSION_FOR_CLUSTER = gql`
  mutation startHtmlMenuScrapingSessionForCluster(
    $id: ID!
    $data: StartHtmlMenuScrapingSessionForClusterInput!
  ) {
    startHtmlMenuScrapingSessionForCluster(id: $id, data: $data) {
      id
    }
  }
`

export default START_HTML_MENU_SCRAPING_SESSION_FOR_CLUSTER
